import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { LeaderboardQuery, LeaderboardResponse, PlayerStatInterval, PlayerStatsResponse, PlayerStatType } from "./dtos";

const STATS_SERVICE = `${Constants.API_URL}/bedrock/stats`;

export class StatsServices {
  @scCatchServiceException()
  static async getLeaderboard(query: LeaderboardQuery): Promise<LeaderboardResponse> {
    const { data } = await axios.post<LeaderboardResponse>(`${STATS_SERVICE}/leaderboard`, query);
    return data;
  }

  @scCatchServiceException()
  static async getPlayerStats(
    intervalType: PlayerStatInterval = "MONTHLY",
    statisticTypes: PlayerStatType[] = [
      "FOLLOWERS",
      "CLICKS",
      "GOALS_POSTED",
      "REACTIONS",
      "COMMENTS",
      "SHARES",
      "IMPRESSIONS",
    ]
  ): Promise<PlayerStatsResponse> {
    const { data } = await axios.post<PlayerStatsResponse>(`${STATS_SERVICE}/player_stats`, {
      intervalType,
      statisticTypes,
    });
    return data;
  }
}
